export const HOME = {
  emergentLink: 'emergent-link',
};

export const AUTH = {
  loginForm: 'login-form',
  loginEmail: 'login-email-input',
  loginPassword: 'login-password-input',
  loginSubmit: 'login-submit-btn',
  loginError: 'login-error-msg',
  registerForm: 'register-form',
  registerSubmit: 'register-submit-btn',
};

export const MASTER = {
  dashboard: 'master-dashboard',
  schoolsList: 'schools-list',
  addSchoolBtn: 'add-school-btn',
  schoolRow: 'school-row',
};

export const SCHOOL = {
  dashboard: 'school-dashboard',
  studentsList: 'students-list',
  addStudentBtn: 'add-student-btn',
  studentRow: 'student-row',
  teachersList: 'teachers-list',
  addTeacherBtn: 'add-teacher-btn',
  classesList: 'classes-list',
  addClassBtn: 'add-class-btn',
};

export const AI = {
  chatInput: 'ai-chat-input',
  chatSend: 'ai-chat-send-btn',
  chatMessage: 'ai-chat-message',
};
